import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "mb-2 field required" }
const _hoisted_3 = { class: "mb-2 field required" }
const _hoisted_4 = {
  key: 0,
  class: "mt-4 flex"
}
const _hoisted_5 = { class: "ml-3" }
const _hoisted_6 = { class: "remove-notice mb-2" }
const _hoisted_7 = { class: "remove-notice mb-2" }
const _hoisted_8 = { class: "remove-notice" }

import { toRefs, ref, watchEffect, computed } from 'vue';
import Calendar from 'primevue/calendar';
import { useOrganizationContractsStore } from '@/store';
import { useDateTime } from '@/composables';
import { ClinicianContractDetails } from '@/types';
import { EMIT } from '@/enum';

interface PropsInterface {
  clinician: ClinicianContractDetails;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'OrganizationContractRemoveServiceProviderModal',
  props: {
    clinician: {}
  },
  setup(__props: any, { emit: __emit }) {

const removeCancelEmit = `${EMIT.REMOVE}-${EMIT.CANCEL}`;
const emit = __emit;
const props = __props;
const { clinician } = toRefs(props);
const contractStore = useOrganizationContractsStore();
const endDate = ref<Date>();
const serviceEndDate = ref<Date>();
const eventsRemoved = ref<number>(0);
const today = ref<Date>(new Date());

const onCancel = () => emit(EMIT.CANCEL);

const onRemove = () =>
  emit(EMIT.REMOVE, { endDate: endDate.value as Date, serviceEndDate: serviceEndDate.value as Date });

const disableButtons = computed(() => !endDate.value || !serviceEndDate.value);

watchEffect(async () => {
  if (serviceEndDate.value) {
    const day = serviceEndDate.value.getDate() - 1;
    const month = serviceEndDate.value.getMonth();
    const year = serviceEndDate.value.getFullYear();
    const checkDate = new Date(year, month, day);
    const { events_count } = await contractStore.checkEventToRemove({
      clinician_id: clinician.value.person?.id,
      start_at: useDateTime().formatDateForApi(contractStore.contract.start_at),
      end_at: useDateTime().formatDateForApi(checkDate),
    });
    eventsRemoved.value = events_count;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_ConfirmAction = _resolveComponent("ConfirmAction")!

  return (_openBlock(), _createBlock(_component_ConfirmAction, {
    header: "Remove Service Provider",
    class: "remove-provider-modal",
    style: { width: '30rem' },
    "content-class": "pb-0",
    "show-footer": true,
    "disable-accept": disableButtons.value,
    "accept-label": "Remove Provider",
    onAccept: onRemove,
    onCancel: onCancel
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[2] || (_cache[2] = _createElementVNode("label", { for: "end_date" }, [
            _createTextVNode(" End Date "),
            _createElementVNode("span", { class: "sub-text" }, "(Service Provider will be removed from the contract on: )")
          ], -1)),
          _createVNode(_unref(Calendar), {
            id: "end_date",
            modelValue: endDate.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((endDate).value = $event)),
            "min-date": today.value,
            class: "w-full",
            placeholder: "01/01/2001",
            "date-format": "mm/dd/yy"
          }, null, 8, ["modelValue", "min-date"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _cache[3] || (_cache[3] = _createElementVNode("label", { for: "service_end_date" }, [
            _createTextVNode(" Service End Date "),
            _createElementVNode("span", { class: "sub-text" }, "(Service Provider cannot create or document events after: )")
          ], -1)),
          _createVNode(_unref(Calendar), {
            id: "service_end_date",
            modelValue: serviceEndDate.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((serviceEndDate).value = $event)),
            "min-date": today.value,
            class: "w-full",
            placeholder: "01/01/2001",
            "date-format": "mm/dd/yy"
          }, null, 8, ["modelValue", "min-date"])
        ])
      ]),
      (endDate.value && serviceEndDate.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_Icon, {
              name: "warning",
              class: "confirm-dialog-icon text-gray-600"
            }),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("p", _hoisted_6, [
                _cache[4] || (_cache[4] = _createTextVNode(" Removing ", -1)),
                _createElementVNode("b", null, _toDisplayString(_unref(clinician).person?.display_name), 1),
                _cache[5] || (_cache[5] = _createTextVNode(" from this contract will remove ", -1)),
                _createElementVNode("b", null, _toDisplayString(eventsRemoved.value), 1),
                _cache[6] || (_cache[6] = _createTextVNode(" events scheduled after ", -1)),
                _createElementVNode("b", null, _toDisplayString(Intl.DateTimeFormat().format(serviceEndDate.value)), 1),
                _cache[7] || (_cache[7] = _createTextVNode(" . ", -1))
              ]),
              _createElementVNode("p", _hoisted_7, [
                _createElementVNode("b", null, _toDisplayString(_unref(clinician).person?.display_name), 1),
                _cache[8] || (_cache[8] = _createTextVNode(" will have until ", -1)),
                _createElementVNode("b", null, _toDisplayString(Intl.DateTimeFormat().format(endDate.value)), 1),
                _cache[9] || (_cache[9] = _createTextVNode(" to create events of this discipline. ", -1))
              ]),
              _createElementVNode("p", _hoisted_8, [
                _createElementVNode("b", null, _toDisplayString(_unref(clinician).person?.display_name), 1),
                _cache[10] || (_cache[10] = _createTextVNode(" will have until ", -1)),
                _createElementVNode("b", null, _toDisplayString(Intl.DateTimeFormat().format(serviceEndDate.value)), 1),
                _cache[11] || (_cache[11] = _createTextVNode(" to document events of this discipline. ", -1))
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["disable-accept"]))
}
}

})